<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <global-table
          :table-data="mitra_coverage"
          :loading="loading"
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="mitraCoverageForm"
          :redirect-detail="false"
          :show-add-button="true"
          caption="<i class='fa fa-align-justify'></i> List Coverage Mitra"
          addButton="Tambah Coverage Mitra"
          @resetForm="resetForm"
          @editForm="editForm"
        ></global-table>
      </b-col>
    </b-row>

    <b-row>
      <b-modal
        ref="myModalRef"
        id="addModals"
        header-border-variant="no-border text-center"
        footer-border-variant="no-border"
        footer-bg-variant="light"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        size="lg"
      >
        <div slot="modal-header" class="text-center">
          <h3 class="text-center">{{ (isEdit) ? 'Edit' : 'Input' }} Mitra Coverage</h3>
        </div>

        <div v-if="loadingSubmit">
          <loading></loading>
        </div>

        <b-form id="mitraCoverageForm" validated novalidate>
          <div v-if="!loadingSubmit">
            <b-row>
              <b-col sm="3">
                <b-form-group label-for="employee_id" label="Group Konsumen">
                  <model-select
                    id="employee_id"
                    :options="listEmployee"
                    v-model="$v.mitraCoverageForm.employee_id.$model"
                    :isError="$v.mitraCoverageForm.employee_id.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>
                  <div
                    v-if="mitraCoverageForm.employee_id === null"
                    class="invalid-feedback-custom"
                  >Group konsumen harus di isi.</div>
                </b-form-group>
              </b-col>

             <b-col sm="3">
                <b-form-group label-for="related_gt" label="Cakupan Konsumen GT">
                  <multi-select
                    :options="listCoverageGT"
                    :selected-options="item_related_gt"
                    placeholder="-- Harap pilih salah satu --"
                    v-model="$v.mitraCoverageForm.customer_gt.$model"
                    :isError="$v.mitraCoverageForm.customer_gt.$invalid"
                    @select="onSelectGT"
                  ></multi-select>
                  <div
                    v-if="mitraCoverageForm.customer_gt === null || mitraCoverageForm.customer_gt.length === 0"
                    class="invalid-feedback-custom"
                  >Group konsumen GT harus di isi.</div>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group label-for="related_non_gt" label="Cakupan Konsumen Non GT">
                  <multi-select
                    :options="listCoverageNonGT"
                    :selected-options="item_related_non_gt"
                    placeholder="-- Harap pilih salah satu --"
                    v-model="$v.mitraCoverageForm.customer_non_gt.$model"
                    :isError="$v.mitraCoverageForm.customer_non_gt.$invalid"
                    @select="onSelectNonGT"
                  ></multi-select>
                  <div
                    v-if="mitraCoverageForm.customer_non_gt === null || mitraCoverageForm.customer_non_gt.length === 0"
                    class="invalid-feedback-custom"
                  >Group konsumen Non GT harus di isi.</div>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </b-form>

        <div slot="modal-footer" class="float-right">
          <div v-if="!loadingSubmit">
            <b-button type="button" size="sm" variant="danger" @click="cancelAdd">
              <i class="fa fa-undo"></i> Back
            </b-button>&nbsp;
            <b-button
              type="button"
              size="sm"
              variant="primary"
              @click="submitAdd"
              :disabled="$v.mitraCoverageForm.$invalid"
            >
              <i class="fa fa-save"></i> Save
            </b-button>
          </div>
        </div>
      </b-modal>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "../../templates/Table.vue";
import interfaces from "@/templates/_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import * as moment from "moment";
import "moment/locale/id";
import { ModelSelect, MultiSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";

export default {
  name: "mitra_coverage",
  components: { globalTable, ModelSelect, MultiSelect, loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      mitra_coverage: [],
      listCoverageNonGT: [],
      listCoverageGT: [],
      listEmployee: [],
      item_related_gt: [],
      item_related_non_gt: [],
      mitraCoverageForm: interfaces.mitra_coverage_survey,
      fields: [
        {
          key: "employee_name",
          label: "Nama Karyawan",
          class: "",
          sortable: true
        },
        { key: "total_customer_gt", label: "Handle GT", sortable: true },
        {
          key: "total_customer_non_gt",
          label: "Handle Non GT",
          sortable: true
        },
        { key: "action", class: "width-50 text-center" }
      ],
      loading: false,
      loadingSubmit: false,
      isEdit: false
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  validations: {
    mitraCoverageForm: {
      employee_id: { required },
      customer_non_gt: { required },
      customer_gt: { required }
    }
  },
  methods: {
    init: function() {
      this.loading = true;
      this.getAllCoverage();
      this.getDropdown();
    },
    getAllCoverage: function() {
      this.axios
        .get("web/mitra/all-mitra-coverage/")
        .then(response => {
          this.mitra_coverage = response.data.data;
        })
        .catch(error => {
          this.expired(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getDropdown: function() {
      this.axios
        .get("web/dropdown/mitra-coverage-related/")
        .then(response => {
          this.listCoverageNonGT = response.data.coverage_non_gt;
          this.listCoverageGT = response.data.coverage_gt;
          this.listEmployee = response.data.employee_mitra;
        })
        .catch(error => {})
        .finally(() => {});
    },
    onSelectGT(items, lastSelectItem) {
      this.item_related_gt = items;
      this.mitraCoverageForm.customer_gt = items;
    },
    onSelectNonGT(items, lastSelectItem) {
      this.item_related_non_gt = items;
      this.mitraCoverageForm.customer_non_gt = items;
    },
    cancelAdd: function() {
      this.resetForm();
      this.$refs.myModalRef.hide();
    },
    editForm: function(e) {
      this.isEdit = true;
      this.mitraCoverageForm = e;
      this.mitraCoverageForm.customer_gt = e.recreate_customer_gt;
      this.mitraCoverageForm.customer_non_gt = e.recreate_customer_non_gt;
      this.item_related_gt = e.recreate_customer_gt; // reset
      this.item_related_non_gt = e.recreate_customer_non_gt; // reset
    },
    resetForm: function() {
      this.isEdit = false;
      this.resetItem();
      for (var a in interfaces.mitra_coverage_survey) {
        interfaces.mitra_coverage_survey[a] = null;
      }
      this.mitraCoverageForm = interfaces.mitra_coverage_survey;
    },
    resetItem() {
      this.item_related_gt = []; // reset
      this.item_related_non_gt = []; // reset
    },
    submitAdd: function(evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin menambahkan karyawan ini ?")) {
        this.loadingSubmit = true;
        if(!this.isEdit) {
            this.axios
            .post("web/mitra/add/", this.mitraCoverageForm)
            .then(response => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Ubah Gudang",
                  message: response.data.message
                });
              }
            })
            .catch(error => {
              this.expired(error);
            })
            .finally(() => {
              this.loadingSubmit = false;
              this.cancelAdd();
              this.init();
            });
        } else {
          this.axios
            .put("web/mitra/update/", this.mitraCoverageForm)
            .then(response => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Ubah Gudang",
                  message: response.data.message
                });
              }
            })
            .catch(error => {
              this.expired(error);
            })
            .finally(() => {
              this.loadingSubmit = false;
              this.cancelAdd();
              this.init();
            });
        }
      }
    },
    expired: function(error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: "Tambah Karyawan",
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style>
</style>